import { z } from "zod";
import { listQuerySchema, optionalEmail, optionalText, optionalUuid } from "./common.js";
export const customerCreateSchema = z.object({
    legalName: z.string().trim().min(1, "Customer name is required.").max(160),
    displayName: optionalText(160),
    phone: optionalText(40),
    email: optionalEmail(),
    notes: optionalText(4000),
});
export const customerUpdateSchema = customerCreateSchema;
export const customerListQuerySchema = listQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    status: z.enum(["lead", "active", "archived"]).optional(),
});
export const contactSchema = z.object({
    name: z.string().trim().min(1, "Contact name is required.").max(120),
    title: optionalText(120),
    phone: optionalText(40),
    email: optionalEmail(),
    isPrimary: z.boolean().default(false),
});
export const addressSchema = z.object({
    kind: z.enum(["billing", "shipping", "site", "other"]).default("other"),
    label: optionalText(120),
    line1: z.string().trim().min(1, "Street address is required.").max(160),
    line2: optionalText(160),
    city: optionalText(120),
    region: optionalText(120),
    postalCode: optionalText(20),
    country: optionalText(80),
});
export const activityCreateSchema = z.object({
    kind: z
        .enum(["call", "meeting", "note", "email", "site_visit", "other"])
        .default("note"),
    summary: z.string().trim().min(1, "A summary is required.").max(2000),
    occurredAt: z.string().datetime({ offset: true }).optional(),
});
export const taskCreateSchema = z.object({
    customerId: z.string().uuid("Invalid customer id."),
    assigneeId: optionalUuid(),
    subject: z.string().trim().min(1, "A subject is required.").max(200),
    notes: optionalText(4000),
    dueAt: z.string().datetime({ offset: true }).optional(),
    priority: z.enum(["low", "medium", "high"]).default("medium"),
});
export const taskListQuerySchema = listQuerySchema.extend({
    assignee: z.string().uuid().optional(),
    customerId: z.string().uuid().optional(),
    status: z.enum(["open", "overdue", "completed"]).optional(),
});
export const customerIdParamSchema = z.object({
    id: z.string().uuid("Invalid customer id."),
});
export const contactIdParamSchema = z.object({
    id: z.string().uuid("Invalid customer id."),
    contactId: z.string().uuid("Invalid contact id."),
});
export const addressIdParamSchema = z.object({
    id: z.string().uuid("Invalid customer id."),
    addressId: z.string().uuid("Invalid address id."),
});
export const taskIdParamSchema = z.object({
    id: z.string().uuid("Invalid task id."),
});
//# sourceMappingURL=crm.js.map